import { Endpoint } from '@business/api/endpoint';
import { TimeMaterialId } from '@business/entities/tm';
import { TMInvoiceScheduleId } from '@business/entities/tm/TMInvoiceScheduleResponse';
import { TMVendorInvoiceId, TMVendorInvoiceResponse } from '@business/entities/tm/TMVendorInvoiceResponse';
import { R } from '@core/utils/r';
import { VendorInvoiceFormData } from '@modules/timeMaterials/TimeMaterialOverlay/Tabs/VendorInvoiceTab/VendorInvoice';

export function fetchVendorInvoices(tmId?: TimeMaterialId) {
  const params = R.objectCompact({ tmId });
  return Endpoint.get<TMVendorInvoiceResponse[]>(`@gc/tm-vendor-invoice`, { params });
}

export function createVendorInvoice(data: Partial<TMVendorInvoiceResponse>) {
  return Endpoint.post<TMVendorInvoiceResponse>(`@gc/tm-vendor-invoice`, { data });
}

export function updateVendorInvoice(id: TMVendorInvoiceId, data: Partial<TMVendorInvoiceResponse>) {
  return Endpoint.patch<TMVendorInvoiceResponse>(`@gc/tm-vendor-invoice/${id}`, { data });
}

export function deleteVendorInvoice(id: TMVendorInvoiceId) {
  return Endpoint.delete<void>(`@gc/tm-vendor-invoice/${id}`);
}

export function fetchVendorInvoice(id: TMVendorInvoiceId) {
  return Endpoint.get<TMVendorInvoiceResponse>(`@gc/tm-vendor-invoice/${id}`);
}

export function createVendorInvoices(tmId: TimeMaterialId, data: VendorInvoiceFormData) {
  return Endpoint.post<TMVendorInvoiceResponse[]>(`@gc/tm-vendor-invoice/invoices/${tmId}`, { data });
}
export function attachVendorInvoice(id: TMVendorInvoiceId, invoiceId: TMInvoiceScheduleId) {
  const data = { invoiceId };
  return Endpoint.post<TMVendorInvoiceResponse>(`@gc/tm-vendor-invoice/attach-invoice/${id}`, { data });
}
